import { render, staticRenderFns } from "./tts-config-pop.vue?vue&type=template&id=505020a0"
import script from "./tts-config-pop.vue?vue&type=script&lang=ts"
export * from "./tts-config-pop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports